import styled from "styled-components";
import {MobileBox as BaseMobileBox, PcBox as BasePcBox} from "./game-title.default.box";
import {styledByDevice} from "../../../../../themes/architecture/styled-by-device";

const PcBox = styled(BasePcBox)`
`;


const MobileBox = styled(BaseMobileBox)`
  font-family: ${props => props.theme.font.family.regular}; 
`;


export const GameTitleCipBox = styledByDevice(PcBox, MobileBox);